import React from "react";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import {
  PanelSearchItemConfig as SearchItemConfig,
  type ButtonConfig,
} from "@ms/shared-components";
import {
  SpaceType as SpaceTypeEnum,
  SpaceStatus,
  Tag,
} from "../../../types/space";

// 空间类型选项配置
export const SPACE_TYPE_OPTIONS = Object.entries({
  [SpaceTypeEnum.BUILDING]: { text: "建筑", color: "orange", label: "建筑" },
  [SpaceTypeEnum.ZONE]: { text: "区域", color: "blue", label: "区域" },
  [SpaceTypeEnum.SPACE]: { text: "空间", color: "green", label: "空间" },
}).map(([key, config]) => ({
  value: key as SpaceTypeEnum,
  label: config.label,
}));

// 空间状态选项配置
export const SPACE_STATUS_OPTIONS = Object.entries({
  [SpaceStatus.ACTIVE]: { text: "启用", color: "green", label: "启用" },
  [SpaceStatus.INACTIVE]: { text: "禁用", color: "red", label: "禁用" },
}).map(([key, config]) => ({
  value: key as SpaceStatus,
  label: config.label,
}));

// 创建标签选项的函数
export const createTagOptions = (tags: Tag[]) => {
  return tags.map((tag) => ({
    value: tag.id,
    label: tag.name,
  }));
};

// 基础搜索项配置（不包含标签）
export const baseSearchItems: SearchItemConfig[] = [
  {
    name: "keyword",
    label: "关键词",
    type: "input",
    props: {
      placeholder: "搜索空间名称或编码",
      allowClear: true,
    },
    colSpan: 6,
  },
  {
    name: "type",
    label: "空间类型",
    type: "select",
    options: SPACE_TYPE_OPTIONS,
    colSpan: 6,
  },
  {
    name: "status",
    label: "状态",
    type: "select",
    options: SPACE_STATUS_OPTIONS,
    props: {
      placeholder: "选择状态",
      allowClear: true,
    },
    colSpan: 6,
  },
];

// 创建包含标签的完整搜索项配置
export const createSearchItems = (tags: Tag[] = []): SearchItemConfig[] => [
  ...baseSearchItems,
  {
    name: "tags",
    label: "标签",
    type: "select",
    options: createTagOptions(tags),
    props: {
      placeholder: "选择标签",
      allowClear: true,
      mode: "multiple",
    },
    colSpan: 6,
  },
];

// 默认搜索项配置（向后兼容）
export const searchItems = baseSearchItems;

// 搜索按钮配置
export const createSearchButtons = (handlers: {
  handleSearchClick: () => void;
  handleReset: () => void;
}): ButtonConfig[] => [
  {
    key: "reset",
    icon: <ReloadOutlined />,
    text: "重置",
    onClick: handlers.handleReset,
    group: "primary",
  },
  {
    key: "search",
    text: "搜索",
    icon: <SearchOutlined />,
    type: "primary",
    onClick: handlers.handleSearchClick,
    group: "primary",
  },
];
